import { Box } from '@mui/material';
import { useLowResolution } from 'hooks';
import React, { FC } from 'react';
import HomeAnalyticsLayout from './components/HomeAnalyticsLayout';
import HomeFooter from './components/HomeFooter';
import HomeHeaderSkeleton from './components/HomeHeaderSkeleton';

const HomePage: FC = () => {
	const lowRes = useLowResolution();

	return (
		<Box
			data-testid="home-page"
			display="flex"
			flexGrow={1}
			flexDirection="column"
			justifyContent="space-between"
			pt={6}
			pb={{
				xs: 0,
				sm: 6
			}}
		>
			{!lowRes && <HomeHeaderSkeleton />}
			<HomeAnalyticsLayout />
			<Box py={5} />
			<HomeFooter />
		</Box>
	);
};

export default HomePage;
